
import {
    getChart,
    getFiltered
} from "../components/api.svelte";

import {
    getLocalPropertyId,
    checkUnauthorized
} from "./session";

import dayjs from "dayjs";
import locale from "dayjs/locale/de";
import customFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customFormat);


export let getRanges = (c, p, n, gap) => {

    let doubleNull = [null, null];

    if (c === 0) {

        return doubleNull;
    }

    let needsGap = (n !== 0 && p !== 0);

    let cum = needsGap ? (c + gap) : c;

    let offset = (cum / 2.0);

    let pos = (p === 0) ? doubleNull : [
        (n - offset) + (needsGap ? gap : 0),
        ((n + p) - offset) + (needsGap ? gap : 0)
    ];

    let neg = (n === 0) ? doubleNull : [
        0.0 - offset,
        (n - offset)
    ];

    return [ pos, neg ];

};

export function tooltipFormatter() {

    let seriesName = this['series']['userOptions']['name'];

    let y = (seriesName === 'percent')
        ? `${Math.round((this.y / 100) * this['series']['userOptions']['size'])} <span class="pct">(${this.y}%)</span>`
        : this.y;

    let x = (this['series']['userOptions']['keyoshtype'] === 'keywords')
        ? this.key
        : this.x;

    if (seriesName === 'origins') {

        x = this['point']['name'];
        y = this['point']['value'];

    }

    let tt =
        `<div class="keyosh-tooltip">
            ${(seriesName !== 'basic' && seriesName !== 'percent' && seriesName !== 'origins')
            ? '<div class="tooltip-id">' + tooltipIdentifiers[seriesName] + '</div>' : ''
        }
            <div class="tooltip-date">${x}</div>
            <div class="tooltip-data">${y}</div>
        </div>`;

    return tt;

}

let tooltipIdentifiers = {

    'pos': 'Positiv',
    'neu': 'Neutral',
    'neg': 'Negativ',
    'fem': 'Frau',
    'mal': 'Mann',
    'ukn': 'Unbekannt',
    'origins': 'Herkunft'

};

export let chartOptions = {
    'dates': {
        'start': 0,
        'end': parseInt(new Date().getTime() / 1000)
    },
    'display': 'all',
    'filter': {
        'platform': 'all',
        'rating': 'all',
        'sentiment': 'all',
        'age': 'all',
        'gender': 'all',
        'origin': 'all'
    },
    'settings': {}
};

export let loadMainChartData = async (router, subChart = false, chartId, chartType, propertyId, filterData) => {

    let chartResult = await getChart(propertyId, chartId, chartType, filterData);

    if (chartResult['status'] !== 'success') {

        if (checkUnauthorized(router, chartResult)) {

            return {};
        }

        console.log(chartResult);

        return {};

    }

    return chartResult['chart'];

};

export let loadSpecialOrFilteredChartData = async (router, subChart, chartId, chartType, propertyId, filterData) => {

    let chartResult;

    chartResult = await getFiltered(propertyId, chartId, chartType, filterData);

    if (chartResult['status'] !== 'success') {

        if (checkUnauthorized(router, chartResult)) {

            return {};
        }

        console.log(chartResult);

        return {};

    }

    return chartResult['results'];

};

export let formatLabels = (format, labels) => {

    let formatted = [];

    if (format === 'day') {

        for (let label in labels) {

            formatted.push(
                dayjs(labels[label], 'DD-MM-YY').locale('de').format('DD. MMM YY')
            );

        }

    } else if (format === 'week') {

        for (let label in labels) {

            let weekSplit = labels[label].split('-');

            formatted.push(
                `KW${weekSplit[0]}` //  ${dayjs(weekSplit[1], 'YYYY').locale('de').format('YY')}
            );

        }

    } else if (format === 'month') {

        for (let label in labels) {

            formatted.push(
                dayjs(labels[label], 'MM-YYYY').locale('de').format('MMM YY')
            );

        }

    } else if (format === 'monthly') {

        for (let label in labels) {

            formatted.push(
                dayjs(labels[label].charAt(0).toUpperCase() + labels[label].slice(1), 'MMM').locale('de').format('MMM')
            );

        }

    } else if (format === 'daily') {

        for (let label in labels) {

            formatted.push(
                getFormattedWeekday(labels[label])
                //dayjs(labels[label].charAt(0).toUpperCase() + labels[label].slice(1), 'ddd', 'en').locale('de').format('ddd')
            );

        }

    } else if (format === 'platforms') {

        for (let label in labels) {

            formatted.push(
                platformIdentifiers[labels[label]]
                //dayjs(labels[label].charAt(0).toUpperCase() + labels[label].slice(1), 'ddd', 'en').locale('de').format('ddd')
            );

        }

    } else if (format === 'ages') {

        for (let label in labels) {

            formatted.push(
                (labels[label] === 'unknown') ? guestsIdentifiers[labels[label]] : labels[label]
            );

        }

    } else if (format === 'genders') {

        for (let label in labels) {

            formatted.push(
                guestsIdentifiers[labels[label]]
            );

        }

    } else if (format === 'origins') {

        for (let label in labels) {

            formatted.push(
                (labels[label] === 'other' || labels[label] === 'unknown') ? guestsIdentifiers[labels[label]] : labels[label]
            );

        }

    } else {

        formatted = labels;

    }

    return formatted;

};

export let colorStops = {
    'basic': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ],
    'pos': [
        [0, '#8FDDFF'],
        [1, '#44FB56']
    ],
    'neu': [
        [0, '#FFA200'],
        [1, '#FFDD00']
    ],
    'neg': [
        [0, '#F63BBE'],
        [1, '#FB4444']
    ],
    'fem': [
        [0, '#FF3782'],
        [1, '#FF37CA']
    ],
    'mal': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ],
    'ukn': [
        [0, '#2BEDF3'],
        [1, '#16E88D']
    ],
    'percent': [
        [0, '#19CEDB'],
        [1, '#16A7E8']
    ]
};

let getFormattedWeekday = (short) => {

    switch (short.toLowerCase()) {

        case 'mon':
            return 'Mo.';

        case 'tue':
            return 'Di.';

        case 'wed':
            return 'Mi.';

        case 'thu':
            return 'Do.';

        case 'fri':
            return 'Fr.';

        case 'sat':
            return 'Sa.';

        case 'sun':
            return 'So.';

    }

};

let guestsIdentifiers = {

    'unknown': 'Unbekannt',
    'woman': 'Frauen',
    'man': 'Männer',
    'other': 'Andere'

};

export let platformIdentifiers = {
    'tripadvisor': 'TripAdvisor',
    'facebook': 'Facebook',
    'google': 'Google'
};

let ageIdentifiers = {

    '13-17': '13 - 17',
    '18-24': '18 - 24',
    '25-34': '25 - 34',
    '35-49': '35 - 49',
    '50-64': '50 - 64',
    '65+': '65+'

};